/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { classNames } from '@/utils';
import { Button } from '../Button';
import { VisualizerMobileOpener } from './VisualizerMobileOpener';
import { VisualizerProvider } from './Visualizer.context';

export interface VisualizerProps {
  /** The title of the visualizer. */
  title: string;
  /** The child nodes of the visualizer. */
  children?: React.ReactNode;
  /** CSS class name(s) to apply to the visualizer container. */
  className?: string;
}

export const Visualizer = React.forwardRef<HTMLDivElement, VisualizerProps>(({ className, children, title }, ref) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <VisualizerProvider
      value={{ open: visible, onOpen: () => setVisible(true), onClose: () => setVisible(false), title }}
    >
      <>
        <section className={classNames('visualizer-container', { visible }, className)} ref={ref}>
          <div className="background-overlay" onClick={() => setVisible(!visible)} />
          <aside className="visualizer visualizer-background">
            <div className="title-wrapper">
              <h4>{title}</h4>
              <Button isIconButton variant="secondary" className="close-visualizer" onClick={() => setVisible(false)}>
                <i className="fa-regular fa-xmark" />
              </Button>
            </div>
            <div className="visualizer-content-wrapper">{children}</div>
          </aside>
        </section>
        <VisualizerMobileOpener />
      </>
    </VisualizerProvider>
  );
});

Visualizer.displayName = 'Visualizer';
